import React, {PureComponent} from 'react'
import './toggleOpen.sass'

export default (OriginalComponent) => class ToggleOpen extends PureComponent {
  state = {
    isOpen: false
  }

  toggleOpen = (ev) => {
    ev && ev.preventDefault && ev.preventDefault()
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handleClick = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  handleClickOverflow = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
    const html = document.querySelector('html')
    html.classList.toggle('overflowHidden')
  }

  render() {
    return <OriginalComponent {...this.props} {...this.state} toggleOpen={this.toggleOpen} handleClick={this.handleClick}  handleClickOverflow={this.handleClickOverflow} />
  }
}



// WEBPACK FOOTER //
// ./decorators/ToggleOpen/index.jsx